import { getCurrentUserInfo } from './auth/auth'

export const segmentLogPage = () => {
  return window.analytics.page()
}
export const segmentLoadKey = () => {
  window.analytics?.load(process.env.REACT_APP_SEGMENT_API)
}
export const segmentIdentify = () => {
  getCurrentUserInfo().then((res) => {
    window.analytics.identify(res.attributes.sub, {
      userName: res.attributes.name,
      email: res.attributes.email,
      phoneNumber: res.attributes.phone_number
    })
  })
}
export const trackApratmentView = (apartmentId: string) => {
  window.analytics.track('apartment were viewed', {
    apartmentId
  })
}
export const trackApplicantView = (userId: string, apartmentId: string) => {
  window.analytics.track('applicant were viewed', {
    userId,
    apartmentId
  })
}
